var path = '/pages/guestlists/views/pages/rsvps/details/messages.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<rsvp-messages ng-if=\"!vm.loading\" rsvp=\"vm.rsvp\"></rsvp-messages>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/rsvps/details/messages.tpl.html
// module id = 2281
// module chunks = 1